import axios from 'axios';
import { toast } from 'react-toastify';
import i18next from 'i18next';
import { getBaseApiUrl } from 'utils';
import { shouldSkipErrorToast } from './toastExclusions';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
};

export const http = axios.create({
  baseURL: getBaseApiUrl(),
  headers,
  withCredentials: true,
});

http.interceptors.response.use(undefined, error => {
  if (!shouldSkipErrorToast(error)) {
    const statusText = error.response?.statusText;
    const message = statusText ? statusText : i18next.t('errors.serverError');

    toast.error(message, {
      autoClose: 5000,
    });
  }

  return Promise.reject(error);
});
